var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "v-height-flag" },
        [
          _c(
            "el-row",
            { staticClass: "plan-title" },
            [
              _c(
                "el-row",
                { staticClass: "p30" },
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.planIndex,
                        callback: function ($$v) {
                          _vm.planIndex = $$v
                        },
                        expression: "planIndex",
                      },
                    },
                    _vm._l(_vm.periodOptions, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        staticClass: "is-active",
                        attrs: { label: item.label, name: String(item.value) },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box" },
            [
              _c("el-row", { staticClass: "mb20", attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticClass: "form-list" },
                  [
                    _c(
                      "label",
                      {
                        staticStyle: { "margin-top": "0" },
                        attrs: { for: "" },
                      },
                      [
                        _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                        _vm._v(
                          " " + _vm._s(_vm.$t("access.openstatus")) + "："
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "form-list-con", attrs: { span: 12 } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-text": _vm.$t("hr.open"),
                            "active-value": 1,
                            "inactive-text": _vm.$t("hr.close"),
                            "inactive-value": 0,
                          },
                          model: {
                            value: _vm.from.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.from, "status", $$v)
                            },
                            expression: "from.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-list" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v(" 创建考核提醒："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { staticClass: "form-list-con", attrs: { span: 12 } },
                          [
                            _vm.planIndex == 1
                              ? _c(
                                  "el-select",
                                  {
                                    staticStyle: { flex: "100%" },
                                    attrs: {
                                      placeholder: "请选择创建考核提醒日期",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.from.remindDays,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.from, "remindDays", $$v)
                                      },
                                      expression: "from.remindDays",
                                    },
                                  },
                                  _vm._l(
                                    _vm.remindDaysData,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.planIndex == 2
                              ? _c(
                                  "div",
                                  { staticClass: "plan-add" },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        max: 28,
                                        min: 1,
                                        precision: 0,
                                        placeholder: "请选择创建考核提醒日期",
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.from.remindDays,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.from, "remindDays", $$v)
                                        },
                                        expression: "from.remindDays",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "days" }, [
                                      _vm._v("号"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.planIndex >= 3
                              ? _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "plan-add",
                                        attrs: {
                                          placeholder: "请选择月份",
                                          size: "small",
                                        },
                                        model: {
                                          value: _vm.from.remindMonth,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.from,
                                              "remindMonth",
                                              $$v
                                            )
                                          },
                                          expression: "from.remindMonth",
                                        },
                                      },
                                      _vm._l(
                                        _vm.months,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: "month" + index,
                                            attrs: {
                                              label: "第" + item + "个月",
                                              value: item,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "plan-days" },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            controls: false,
                                            max: 28,
                                            min: 1,
                                            precision: 0,
                                            placeholder:
                                              "请选择创建考核提醒日期",
                                            size: "small",
                                          },
                                          model: {
                                            value: _vm.from.remindDays,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "remindDays",
                                                $$v
                                              )
                                            },
                                            expression: "from.remindDays",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "days" }, [
                                          _vm._v("号"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "assess-info", attrs: { span: 24 } },
                          [
                            _vm._v(
                              "用于设置提醒考核人，为被考核人制定考核目标的时间"
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-list" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v(" 自我评价提醒："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-row",
                              { staticClass: "width100" },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { flex: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "finance.pleaseselect"
                                          ),
                                          size: "small",
                                        },
                                        on: { change: _vm.handleMake },
                                        model: {
                                          value: _vm.from.make,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.from, "make", $$v)
                                          },
                                          expression: "from.make",
                                        },
                                      },
                                      _vm._l(
                                        _vm.makeOptions,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "plan-days",
                                    attrs: { span: 12 },
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        max: 3650,
                                        min: 0,
                                        placeholder: _vm.$t(
                                          "access.numberofdays"
                                        ),
                                        precision: 0,
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.days.makeDays,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.days, "makeDays", $$v)
                                        },
                                        expression: "days.makeDays",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "days" }, [
                                      _vm._v(_vm._s(_vm.$t("access.day"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "assess-info", attrs: { span: 24 } },
                          [
                            _vm._v(
                              "用于设置提醒被考核人，进行考核自我评价的时间"
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-list" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v(" 上级评价提醒："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-row",
                              { staticClass: "width100" },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { flex: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "finance.pleaseselect"
                                          ),
                                          size: "small",
                                        },
                                        model: {
                                          value: _vm.from.eval,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.from, "eval", $$v)
                                          },
                                          expression: "from.eval",
                                        },
                                      },
                                      _vm._l(
                                        _vm.evalOptions,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "plan-days",
                                    attrs: { span: 12 },
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        max: 100,
                                        min: 0,
                                        placeholder: _vm.$t(
                                          "access.numberofdays"
                                        ),
                                        precision: 0,
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.days.evalDays,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.days, "evalDays", $$v)
                                        },
                                        expression: "days.evalDays",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "days" }, [
                                      _vm._v(_vm._s(_vm.$t("access.day"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "assess-info", attrs: { span: 24 } },
                          [
                            _vm._v(
                              "用于设置提醒考核人，对直属下级考核完成情况进行上级评价打分的时间"
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-list" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v(" 考核自动结束："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-row",
                              { staticClass: "width100" },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: true,
                                        placeholder: _vm.$t(
                                          "access.superiorevaluation"
                                        ),
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.from.verify,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.from, "verify", $$v)
                                        },
                                        expression: "from.verify",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "plan-days",
                                    attrs: { span: 12 },
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        controls: false,
                                        max: 100,
                                        min: 0,
                                        placeholder: _vm.$t(
                                          "access.numberofdays"
                                        ),
                                        precision: 0,
                                        size: "small",
                                      },
                                      model: {
                                        value: _vm.days.verifyDays,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.days, "verifyDays", $$v)
                                        },
                                        expression: "days.verifyDays",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "days" }, [
                                      _vm._v(_vm._s(_vm.$t("access.day"))),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "assess-info", attrs: { span: 24 } },
                          [
                            _vm._v(
                              "用于设置上级评价完成后，考核流转为【结束】状态的时间"
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-list",
                    staticStyle: { "align-items": "normal" },
                  },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v(" 被考核人："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          {
                            staticClass: "resource-check",
                            attrs: { span: 12 },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.from.resource,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.from, "resource", $$v)
                                  },
                                  expression: "from.resource",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("按部门添加"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("按人员添加"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "assess-info" }, [
                            _vm._v(
                              "\n                按部门添加用于本部门所有人员均需参加考核的情况；按人员添加用于特殊个例人员需要参加考核的情况\n              "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-list" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _c("span", { staticClass: "color-tab" }, [_vm._v("*")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.from.resource == 0
                              ? _vm.$t("access.assessee")
                              : "被考核部门"
                          ) +
                          "："
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticClass: "form-list-con",
                        staticStyle: { width: "40%" },
                        attrs: { span: 22 },
                      },
                      [
                        _vm.from.resource == 0
                          ? _c("select-member", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                value: _vm.departmentObj.userList || [],
                                placeholder: _vm.$t("access.tips15"),
                              },
                              on: { getSelectList: _vm.getSelectList },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.from.resource == 1
                          ? _c("select-department", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                value: _vm.departmentObj.frames || [],
                                placeholder: _vm.$t("access.tips15"),
                              },
                              on: { changeMastart: _vm.changeMastart },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-list",
                    staticStyle: { "margin-top": "10px" },
                  },
                  [
                    _c("label", { attrs: { for: "" } }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handlePreserve(2)
                          },
                        },
                      },
                      [_vm._v("保存查看被考核人员详情")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cr-bottom-button" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["hr:assessConfig:assessmentPlan:save"],
                      expression: "['hr:assessConfig:assessmentPlan:save']",
                    },
                  ],
                  attrs: {
                    loading: _vm.loading,
                    size: "small",
                    type: "primary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handlePreserve(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("public.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("assess-box", { ref: "assessBox" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }